import { motion } from 'framer-motion'
import styles from './Footer.module.css'

const footerLinks = {
  product: [
    { label: 'GitHub', href: 'https://github.com/luminox-mem/luminox' },
    { label: 'npm Package', href: 'https://www.npmjs.com/package/luminox-sdk' },
    { label: 'Issues', href: 'https://github.com/luminox-mem/luminox/issues' },
  ],
  resources: [
    { label: 'README', href: 'https://github.com/luminox-mem/luminox#readme' },
    { label: 'Examples', href: 'https://github.com/luminox-mem/luminox/tree/main/src/client' },
    { label: 'Quickstart', href: '#quickstart' },
  ],
  community: [
    { label: 'Contributing', href: 'https://github.com/luminox-mem/luminox/blob/main/CONTRIBUTING.md' },
    { label: 'Code of Conduct', href: 'https://github.com/luminox-mem/luminox/blob/main/CODE_OF_CONDUCT.md' },
    { label: 'License', href: 'https://github.com/luminox-mem/luminox/blob/main/LICENSE' },
  ],
}

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <motion.div
          className={styles.brand}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <div className={styles.logo}>
            <motion.span
              className={styles.logoIcon}
              animate={{
                textShadow: [
                  '0 0 10px rgba(255, 215, 0, 0.3)',
                  '0 0 20px rgba(255, 215, 0, 0.5)',
                  '0 0 10px rgba(255, 215, 0, 0.3)',
                ],
              }}
              transition={{ duration: 2, repeat: Infinity }}
            >
              &#9672;
            </motion.span>
            <span className={styles.logoText}>LUMINOX</span>
          </div>
          <p>Context Data Platform for AI Agents</p>
        </motion.div>

        <div className={styles.links}>
          <motion.div
            className={styles.column}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <h5>Product</h5>
            {footerLinks.product.map((link) => (
              <a key={link.href} href={link.href} target="_blank" rel="noopener noreferrer">
                {link.label}
              </a>
            ))}
          </motion.div>

          <motion.div
            className={styles.column}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <h5>Resources</h5>
            {footerLinks.resources.map((link) => (
              <a key={link.href} href={link.href} target="_blank" rel="noopener noreferrer">
                {link.label}
              </a>
            ))}
          </motion.div>

          <motion.div
            className={styles.column}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <h5>Community</h5>
            {footerLinks.community.map((link) => (
              <a key={link.href} href={link.href} target="_blank" rel="noopener noreferrer">
                {link.label}
              </a>
            ))}
          </motion.div>
        </div>
      </div>

      <motion.div
        className={styles.bottom}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.4 }}
      >
        <p>&copy; 2025 Luminox. Licensed under Apache 2.0.</p>
      </motion.div>
    </footer>
  )
}
